import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

export default function Step1BasicInfo({ formData, setFormData, generateSlug, handleNameChange }) {
  return (
          <Card>
            <CardHeader>
              <CardTitle>Club Information</CardTitle>
              <CardDescription>Tell us about your new club</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <Label htmlFor="name">Club Name *</Label>
                <Input
                  id="name"
                  value={formData.name}
                  onChange={handleNameChange}
                  placeholder="e.g., Golden Retriever Lovers Club"
                  data-testid="club-name-input"
                />
              </div>
              
              <div>
                <Label htmlFor="slug">URL Slug *</Label>
                <div className="flex items-center gap-2">
                  <span className="text-sm text-muted-foreground">americandogclub.com/</span>
                  <Input
                    id="slug"
                    value={formData.slug}
                    onChange={(e) => setFormData(prev => ({ ...prev, slug: generateSlug(e.target.value) }))}
                    placeholder="golden-retriever-lovers"
                    className="flex-1"
                    data-testid="club-slug-input"
                  />
                </div>
              </div>
              
              <div>
                <Label htmlFor="tagline">Tagline *</Label>
                <Input
                  id="tagline"
                  value={formData.tagline}
                  onChange={(e) => setFormData(prev => ({ ...prev, tagline: e.target.value }))}
                  placeholder="A short, catchy description"
                  data-testid="club-tagline-input"
                />
              </div>
              
              <div>
                <Label htmlFor="motto">Club Motto</Label>
                <Input
                  id="motto"
                  value={formData.motto}
                  onChange={(e) => setFormData(prev => ({ ...prev, motto: e.target.value }))}
                  placeholder="e.g., 'Where Every Pup is a Champion'"
                  data-testid="club-motto-input"
                />
              </div>
              
              <div>
                <Label htmlFor="description">Description *</Label>
                <Textarea
                  id="description"
                  value={formData.description}
                  onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
                  placeholder="Tell potential members what your club is about, what activities you offer, who should join..."
                  rows={3}
                  data-testid="club-description-input"
                />
              </div>
              
              <div>
                <Label htmlFor="purpose">Purpose Statement</Label>
                <Textarea
                  id="purpose"
                  value={formData.purpose}
                  onChange={(e) => setFormData(prev => ({ ...prev, purpose: e.target.value }))}
                  placeholder="Why does this club exist? What problem does it solve or need does it meet?"
                  rows={2}
                  data-testid="club-purpose-input"
                />
              </div>
              
              <div>
                <Label htmlFor="mission">Mission Statement</Label>
                <Textarea
                  id="mission"
                  value={formData.mission}
                  onChange={(e) => setFormData(prev => ({ ...prev, mission: e.target.value }))}
                  placeholder="What are your club's long-term goals?"
                  rows={2}
                  data-testid="club-mission-input"
                />
              </div>
            </CardContent>
          </Card>
  );
}
